<template>
  <vue-dropzone
    id="dropzone"
    ref="upload"
    :options="options"
    @vdropzone-removed-file="removeFile"
    @vdropzone-sending="addFile"
    @vdropzone-error="onError"
    @vdropzone-success="onSuccess"
  />
</template>
<script>
import vue2Dropzone from "vue2-dropzone";
/* eslint-disable */
import dropzonecss from "vue2-dropzone/dist/vue2Dropzone.min.css";
/* eslint-enable */
import { mapActions } from 'vuex';

export default {
  name: "StakeholderFileDropzone",
  components: {
    vueDropzone: vue2Dropzone
  },
  props: { stakeholder: { type: Object, default: () => {} } },
  data() {
    return {
      success: false,
      isDestroying: false,
      options: {
        url: `${process.env.VUE_APP_DRF_API_URL}/stakeholder_files/`,
        // maxFiles: 1,
        dictDefaultMessage: "Please Upload the File Here",
        // Header settings might be different for S3 Bucket
        headers: {
          "Cache-Control": "",
          "X-Requested-With": "",
          "Authorization": `JWT ${localStorage.getItem("TOKEN_STORAGE_KEY")}`
        },
        addRemoveLinks: true
      }
    }
  },
  beforeDestroy() {
    this.isDestroying = true;
  },
  methods: {
    ...mapActions({
      deleteStakeholderFile: "stakeholderFiles/deleteStakeholderFile",
      addStakeholderFile: "stakeholderFiles/addStakeholderFile"
    }),
    addFile(file, xhr, formData) {
      // This adds a parameter to the payload (so the number needs to be a mapState connected to whatever the instance is)
      formData.append('file_name', file.name)
      formData.append('stakeholder', this.stakeholder.pk)
    },
    removeFile(file) {
      // This eventually needs to go inside of a module/service
      if (!this.isDestroying) {
        const response = JSON.parse(file.xhr.response)
        this.deleteStakeholderFile(response.pk)
      } else {
        this.isDestroying = false;
      }
    },
    onError(file, msg, xhr) {
      alert(xhr.statusText);
      this.success = false;
    },
    onSuccess(file, response) {
      this.success = true;
      this.addStakeholderFile(response);
      this.isDestroying = true;
      setTimeout(() => {
        this.$refs.upload.removeFile(file)
      }, 2000)
    }
  }
}
</script>
<style scoped>

</style>